import { render, staticRenderFns } from "./SendMessageEvaluate.vue?vue&type=template&id=10abb176"
import script from "./SendMessageEvaluate.vue?vue&type=script&lang=js"
export * from "./SendMessageEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports